import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ThanksVIP.css';

function ThanksVIP() {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(prev => !prev);
  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="thanks-container">
      {/* 导航栏（与首页保持一致，保证风格统一） */}
      <nav className="navbar">
        <div className="navbar-logo">
          <h2>消防操作员备考助手</h2>
        </div>
        <button
          className={`navbar-toggle ${menuOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label="菜单"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className={`navbar-menu ${menuOpen ? 'open' : ''}`}>
          <Link to="/" onClick={closeMenu}>首页</Link>
          <Link to="/#features" onClick={closeMenu}>软件特色</Link>
          <Link to="/#download" onClick={closeMenu}>立即下载</Link>
        </div>
      </nav>

      {/* VIP感谢核心内容区 */}
      <section className="thanks-section">
        <div className="thanks-card">
          {/* 成功图标（视觉提示） */}
          <div className="success-icon">✓</div>
          <h1>恭喜您！VIP开通成功</h1>
          <p className="thanks-desc">
            感谢您选择消防操作员备考助手，您已解锁全部VIP权益，祝您顺利上岸中级消防设施操作员考试！
          </p>
          {/* 新增：VIP状态更新提醒（醒目提示） */}
          <div className="vip-notice">
            <h4 className="notice-title">⚠️ 重要提醒</h4>
            <p className="notice-content">
              如果软件内VIP状态未及时更新，<strong>请勿重复支付！</strong>
            </p>
            <p>请先关闭软件，重新启动后即可同步VIP状态。</p>
          </div>
          {/* VIP权益提示（强化用户感知） */}
          <div className="vip-benefits">
            <h3>您已解锁的VIP专属权益</h3>
            <ul>
              <li>✅ 解析无限制查看</li>
              <li>✅ 全真模拟考试无限次使用</li>
              <li>✅ 错题本+收藏+专属学习情况统计</li>
              <li>✅ 免费获取后续考试题库更新</li>
            </ul>
          </div>



        </div>
      </section>

      {/* 底部信息（与首页保持一致） */}
      <footer className="footer">
        <p>© 2026 上岸消考 版权所有 | 专注中级消防设施操作员考试上岸</p>
        <p>联系我们：xxxxx@163.com</p>
      </footer>
    </div>
  );
}


export default ThanksVIP;